import { useEffect, useRef } from 'react';
import './BottomSheet.scss';

const BottomSheet = ({
  title,
  children,
  open,
  classNames,
  onClose,
  styles,
}) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    const div = wrapperRef.current;
    if (!div) return;

    const handleKeyDown = event => {
      if (event.key === 'Escape' && onClose) {
        onClose();
      }
    };

    div.addEventListener('keydown', handleKeyDown);

    return () => {
      div.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div
      className={'bottom-sheet-root ' + classNames?.root}
      style={{ ...(styles?.root ?? {}) }}
    >
      <div
        className={
          'bottom-sheet-mask ' + (open ? 'open ' : '') + classNames?.mask
        }
        style={{ ...(styles?.mask ?? {}) }}
        onClick={onClose}
      ></div>
      <div
        ref={wrapperRef}
        className={
          'bottom-sheet-wrapper ' + (open ? 'open ' : '') + classNames?.wrapper
        }
        style={{ ...(styles?.wrapper ?? {}) }}
        tabIndex={0}
      >
        <div className="bottom-sheet-content">
          <div
            className={'bottom-sheet-title ' + classNames?.title}
            style={{ ...(styles?.title ?? {}) }}
          >
            {title}
          </div>
          <div
            className={'bottom-sheet-body ' + classNames?.body}
            style={{ ...(styles?.body ?? {}) }}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomSheet;
